import jQuery from 'jquery';
import MotionUI from 'motion-ui/dist/motion-ui.js';

import PiecemealLoader from '@scripts/piecemeal-loader.js';

var OffCanvas = function(element) {
  this.element = element;

  this.onToggleClick = this.onToggleClick.bind(this);
};
OffCanvas.prototype.activeCanvasClass = 'is-active';
OffCanvas.prototype.initialise = function() {
  this.id = this.element.attr('id');

  var steps = [
    this.getElements.bind(this),
    this.findToggles.bind(this),
    this.attachClickEvents.bind(this)
  ];

  var tmp = new PiecemealLoader(steps);
  tmp.initialise();
};
OffCanvas.prototype.getElements = function() {
  this.background = this.element.find('[data-sbmoc-background]');
  this.content = this.element.find('[data-sbmoc-content]');
};
OffCanvas.prototype.findToggles = function() {
  this.toggles = jQuery('[data-sbmoc-toggle="' + this.id + '"]');
};
OffCanvas.prototype.attachClickEvents = function() {
  this.toggles.on('click', this.onToggleClick);
  this.content.children().on('transitionend', this.stopTransitionPropagation);
};
OffCanvas.prototype.onToggleClick = function(event) {
  event.preventDefault();

  if (! this.element.hasClass(this.activeCanvasClass)) {
    this.show();
  } else {
    this.hide();
  }
};
/**
 * Stop the 'transitionend' events from bubbling up to the content element.
 * The Animation library we use relies on this event to tell us that animations
 * have completed, which caused issues as a child's transition would end, but
 * not the content's transition, and that was prematurely causing the library
 * to believe that animations were over
 */
OffCanvas.prototype.stopTransitionPropagation = function(event) {
  event.stopPropagation();
};
OffCanvas.prototype.show = function() {
  this.element.addClass(this.activeCanvasClass);

  MotionUI.animateIn(this.background, 'fade-in');
  MotionUI.animateIn(this.content, 'slide-in-left');

  this.element.trigger('sbm:off-canvas:show');
};
OffCanvas.prototype.hide = function() {
  var that = this;

  MotionUI.animateOut(this.background, 'fade-out');
  MotionUI.animateOut(this.content, 'slide-out-left', function() {
    that.element.removeClass(that.activeCanvasClass);
  });
};

jQuery(function(jQuery) {
  var offCanvas = jQuery('[data-sbm-off-canvas]');

  if (offCanvas.length) {
    for (var i = 0; i < offCanvas.length; i++) {
      var item = jQuery(offCanvas[i]);

      var block = new OffCanvas(item);
      block.initialise();
    }
  }
});

